module.exports = __webpack_public_path__ + "img/service_light_hover.39713174.svg";